/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Sections/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Section from './Section/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Sections({
  children,
  viewPath = "/DesignSystem/ImageComparison/Content/Sections"
  
}) {
let comparisonOrientationValueData = fromData.useDataFormat({ viewPath,
context: 'comparison',
path: 'orientation',
format: fromHelpers.getFlexDirection,
})
let comparisonImagesValueData = fromData.useDataValue({ viewPath,
context: 'comparison',
path: 'images',
})
  return (<React.Fragment
>
<div
  data-testid="Sections.List"
  data-view-path={viewPath}
 style={{'--fd-1-1c851z': comparisonOrientationValueData}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(comparisonImagesValueData) && comparisonImagesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="comparison_section"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Section(${item?.id ?? item?._id ?? index})`}
      >
<Section
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Section(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }